<template>
  <AuthLayout :mode="mode">
    <ManufacturersActions type="edit" :mode="mode" />
  </AuthLayout>
</template>

<script>
import ManufacturersActions from "@C/ManufacturersActions.vue";
import AuthLayout from "@A/AuthLayout.vue";

export default {
  name: "EditManufacturer",
  components: {
    AuthLayout,
    ManufacturersActions,
  },
  props: {
    mode: String,
  },
};
</script>
